import Vue from 'vue'
import Vuex from 'vuex'
import Axios from "axios/index";
import router from '@/router';
import Toasted from 'vue-toasted';
import { getLocalData } from '../helpers'

Vue.use(Vuex);

Vue.use(Toasted, { 'position': 'bottom-left', 'duration': 2000 });

export default new Vuex.Store({
    state: {
        // Institute info
        institute_info:{
            title:"",
            URL:"",
            Date:"",
            enamad:"",
        },
        /* general variables */
        requestQueue: [],
        queueStatus: 0,
        is_loading:true,
        alertList: [],
        baseColor: 'black',
        //Former serverURL
        //serverURL: 'http://test.bp1.ir',
        serverURL: 'https://pay.sharif.edu',
        get4watch: {
            getQueueStatus: state => state.queueStatus,
            getAlertList: state => state.alertList
        },

        // **********************
        loginData: { mobile: '', waitSecond: 0, mobileResult: {}, code: "", codeRequestData: {} },
        tracks: [],
        trackPagination: {
            page: 1,
            take: 10,
            count: 0
        },
        reports: [],
        loadReportIsLoading : null, //TODO::Look ME!!!
        reportPagination: {
            page: 1,
            take: 10,
            count: 0
        },
        ownerGWDDL: [],
        sumOfPayments: 0,
        groupDDLList: [],
        userGWDDL: [],
        userGroupDDL: [],
        userGroupLoad: {
            Default_Amount: 0,
            EMail_Enable: false,
            Family_Enable: false,
            Memo_Enable: false,
            Memo_Title: "",
            Mobile_Enable: false,
            NC_Enable: false,
            Name_Enable: false,
            Tel_Enable: false
        } , 
        userGroupLoad_two: ''
        ,
        currentUserPayment: {

        },
        flag: true,
        orderID: "",
       //url: "",

        list_for_download:[],

       //refId: ""
        PaymentStatus:{},//look at me
        focus: ''
    },
    getters: {
        getQueueStatus: state => state.queueStatus,
        getRequestQueue: state => state.requestQueue,
        getServerURL: state => state.serverURL,
        getLoginData: state => state.loginData,
        geCodeSearchData: state => state.codeSearchData,
        getAlertList: state => state.alertList,
        get_is_loading: state => state.is_loading,
    },
    mutations: {
        /** setters ****************/
        setToken: (state, payload) => state.token = payload.token,
        addToAlertList: (state, payload) => state.alertList.push(payload),
        setLoginData: (state, payload) => state.loginData = payload.loginData,
        resetAlertList: (state) => state.alertList = [],
        setLoadReportIsLoading : (state, payload) => state.loadReportIsLoading = payload.newStatus, //TODO:: LOOK at me!!

        /* queue functions */
        updateInstituteInfo:(state, payload) => state.institute_info = payload.institute_info,
        setQueueStatus: (state, payload) => state.queueStatus = payload.queueStatus,
        shiftRequestQueue: (state) => state.requestQueue.shift(),
        incrementQueueError: (state) => state.requestQueue[0].countError = (state.requestQueue[0].countError ? state.requestQueue[0].countError++ : 1),
        pushQueue(state, payload) {
            window.console.log(`*********************************`);
            window.console.log(`pushQueue is called!, state is ${state} and payload.functionName is ${payload.functionName}`);
            let initialData = { "Ch": 1, FN: payload.functionName };
            window.console.log(`initialData is ${initialData}`);
            payload.data = payload.data.length === 0 ? {} : payload.data;
            state.requestQueue.push({ ...initialData, ...payload.data });
            if (state.queueStatus === 0)
                state.queueStatus = 1;
        },
        navigate(state, payload) {
            window.console.log(`*********************************`);
            window.console.log(`navigate is called, payload.url is ${payload.url} and state is ${state}`);
            window.console.log(`router.currentRoute.path is ${router.currentRoute.path}`);
            if (router.currentRoute.path !== payload.url)
                window.location.href = payload.url;
        },
        updateTracks(state, payload) {
            window.console.log(`state is ${state}`);
            window.console.log(`payload is ${payload}`);
            window.console.log(payload);
            state.tracks = payload.tracks;
        },
        updateTrackPagination(state, payload) {
            state.trackPagination.count = payload.count;
        },
        set_list_for_download:(state, {list_for_download}) => state.list_for_download = list_for_download,

        updateReports(state, payload) {
            window.console.log("updateReports is called!");
            window.console.log(`state is ${state}`);
            window.console.log(`payload is ${payload}`);
            state.reports = payload.reports;
        },
        updateOwnerGWDDL(state, payload) {
            window.console.log(payload.ownerGWDDL);
            state.ownerGWDDL = payload.ownerGWDDL;
            //state.ownerGWDDL.push(payload.ownerGWDDL);
            //state.ownerGWDDL
            window.console.log("*************");
            window.console.log(state.ownerGWDDL);
        },
        updateUserGWDDL(state, payload) {
            state.userGWDDL = payload.userGWDDL;
        },
        updateUserGroupDDL(state, payload) {
            state.userGroupDDL = payload.userGroupDDL;
        },
        updateReportPagination(state, payload) {
            window.console.log(`state is ${state}`);
            window.console.log(`payload is ${payload}`);
            state.reportPagination.count = payload.count;
        },
        updateSumOfPayments(state, payload) {
            state.sumOfPayments = payload.sum;
        },
        updateGroupDDLList(state, payload) {
            window.console.log(`updateGroupDDLList is called`);
            state.groupDDLList = payload.groupDDL;
        },
        updateUserGroupLoad(state, payload) {
            if (payload.userGroupLoad.Default_Amount < 0) {
                payload.userGroupLoad.Default_Amount = ""
            }
            state.userGroupLoad = payload.userGroupLoad;
        },
        updateCurrentUserPayment(state, payload) {
            window.console.log(payload , 'mahmood');
            window.console.log("&&&&&&&&&&&&&&&&&&&&&&&&");
            window.console.log("&&&&&&&&&&&&&&&&&&&&&&&&");
            window.console.log("&&&&&&&&&&&&&&&&&&&&&&&&");
            window.console.log(payload.currentUserPayment.User_Submit_Load);
            state.currentUserPayment = payload.currentUserPayment.User_Submit_Load;
            state.userGroupLoad_two = payload.currentUserPayment.User_Group_Load;
        },

        changeFlag(state, payload) {
            state.flag = payload.flag
        },
        updatePaymentStatus(state, payload){//look at me
            state.PaymentStatus=payload.User_Payment_Status.User_Payment_Status;
            state.userGroupLoad_two = payload.User_Payment_Status.User_Group_Load;
        },
        setFocus(state , payload){
            state.focus = payload.Focus;
        }
        /* redirectUser(state, payload) {
             let form = document.createElement("form");
             form.setAttribute("method", "POST");
             form.setAttribute("action", payload.url);
             form.setAttribute("target", "_self");
             let hiddenField = document.createElement("input");
             hiddenField.setAttribute("name", payload.refId);
             hiddenField.setAttribute("value", document.getElementById("txtRefId").value);
             form.appendChild(hiddenField);
             document.body.appendChild(form);
             form.submit();
             document.body.removeChild(form);?
             state.url = payload.url;
             state.refId = payload.refId;
         }*/
    },
    actions: {
        callServer({ commit, getters, dispatch }) {
            commit('setQueueStatus', { queueStatus: 2 });
            let reqQueue = getters.getRequestQueue;
            window.console.log(reqQueue[0]);
            commit('setLoadReportIsLoading',{newStatus : reqQueue[0].FN}); //loading
            window.console.log(reqQueue[0].FN);
            let formData = new FormData();
            formData.append("Input", JSON.stringify(reqQueue[0]));

            if (reqQueue[0].FN === "File" && reqQueue[0].Action === "Upload") {
                formData.append("File", reqQueue[0].file, reqQueue[0].imageName);
            }

            Axios({
                url: getters.getServerURL + "/api/API/",
                data: formData,
                processData: false,
                contentType: false,
                method: "POST"
            })
                .then((response) => {
                    dispatch('processResult', { sentData: reqQueue[0], response: response.data });
                    commit('shiftRequestQueue');
                    commit('setQueueStatus', { queueStatus: (getters.getRequestQueue).length === 0 ? 0 : 1 });
                    commit('setLoadReportIsLoading',{newStatus : null});//TODO::Look at ME

                })
                .catch(error => {
                    commit('setLoadReportIsLoading',{newStatus : null});//TODO::Look at ME
                    window.console.log(error);
                    commit('incrementQueueError');
                    if (reqQueue[0].countError >= 3) {
                        commit('shiftRequestQueue');
                        commit("addToAlertList", {
                            "text": 'امکان اتصال به سرور وجود ندارد: ' +
                                '<br/>' +
                                'اینترنت را چک کنید',
                            "type": "error"
                        });
                    }
                    if (error === "timeout")
                        commit('setQueueStatus', { queueStatus: 1 });
                    else setTimeout(() => {
                        commit('setQueueStatus', { queueStatus: 1 });
                    }, 6e3)
                });
        },
        processResult({ commit, dispatch }, payload) {
            window.console.log("---------- process result ---------");
            window.console.log(payload);

            let response = payload.response;
            let sentData = payload.sentData;
            //let tempData = {};
            if (response.Result <= -1000) {
                if (response.Result === -1000) {
                    window.console.log('loginPage');
                    dispatch('loginPage');
                } else
                    return;
            }
            let needAlert = false;
            response.Message = (response.Message ? response.Message : "");
            response.Result = response.Result ? response.Result : 0;
            switch (sentData.FN) {
                case "Start":
                    needAlert = false;
                    if (response.Result === 0) {
                        commit("updateInstituteInfo", { "institute_info": response.Start });
                    }
                    break;

                case "User_Payment_Track":
                    needAlert = true;
                    if (response.Result === 0) {
                        commit("updateTracks", { "tracks": response.User_Payment_Track });
                        commit("updateTrackPagination", { "count": response.Count });

                    }else if (response.Result === -1){
                        commit("updateTrackPagination", { "count": response.Count });

                    }
                    break;

                case "User_GW_DDL":
                    needAlert = true;
                    if (response.Result === 0) {
                        commit("updateUserGWDDL", { "userGWDDL": response.User_GW_DDL });
                    }
                    break;

                case "User_Group_DDL":
                    needAlert = true;
                    if (response.Result === 0) {
                        commit("updateUserGroupDDL", { "userGroupDDL": response.User_Group_DDL });
                    }
                    break;

                case "User_Group_Load":
                    needAlert = false;
                    if (response.Result === 0) {
                        commit("updateUserGroupLoad", { "userGroupLoad": response.User_Group_Load });
                    }
                    break;

                case "User_Payment_Insert":
                    needAlert = true;
                    if (response.Result === 0) {
                      
                        setTimeout(function () {
                            router.push({ name: 'submit', params: { Gateway: response.GWID, OrderID:response.OrderID} })
                        },1000)
                    }
                    else{
                        commit('setFocus' , response);
                    }
                    break;
                case "User_Submit_Load":
                    needAlert = true;
                    if (response.Result === 0) {
                        
                        // if(response.User_Group_Load.AutoSubmit){
                        //     window.location.href = 'https://bpm.shaparak.ir/pgwchannel/startpay.mellat'
                        // }
                        // else{
                        // } 
                        commit('updateCurrentUserPayment', { "currentUserPayment": response });

                    }
                    break;
                case "User_GoIPG":
                    needAlert = true;
                    if (response.Result === 0) {
                        //commit("redirectUser", { "url": response.IPGURL, "refId": response.RefId });
                        if (response.IPGURL && response.IPGURL.length > 0)
                        window.console.log(response , 'response');
                            setTimeout(function () {
                                if(response.IPGName == 'bpm' || response.IPGName == 'bpm2'){
                                    window.location.href = response.IPGURL + "?RefId=" + response.RefId;
                                }
                                if(response.IPGName == 'sadad'){
                                    window.location.href = response.IPGURL + "?token=" + response.RefId;
                                }
                                // response.IPGName == 'Iran kish'
                                else{
                                    var form = document.createElement("form");
                                    form.setAttribute("method", "POST");
                                    form.setAttribute("action", response.IPGURL);
                                    form.setAttribute("target", "_self");
                                    var hiddenField = document.createElement("input");
                                    hiddenField.setAttribute("name", "tokenIdentity");
                                    hiddenField.setAttribute("value", response.RefId);
                                    form.appendChild(hiddenField);
                                    document.body.appendChild(form);
                                    form.submit();
                                    document.body.removeChild(form);
                                }
                            },1000)
                    }
                    break;

                case "Owner_GW_DDL":
                    needAlert = false;
                    if (response.Result === 0) {
                        commit("updateOwnerGWDDL", { "ownerGWDDL": response.Owner_GW_DDL });
                    }
                    break;

                case "Owner_Report":
                    needAlert = true;
                    if (response.Result === 0 && response.Message === "") {
                        if (response.Count === 0) {
                            commit("addToAlertList", {
                                "text": 'کاربر گرامی: محتوایی برای نمایش وجود ندارد.',
                                "type": "error"
                            });
                        }
                        commit('updateReports', { "reports": response.Owner_Report });
                        commit('updateReportPagination', { "count": response.Count });
                        commit('updateSumOfPayments', { "sum": response.Sum });
                    }
                    commit("set_list_for_download", {list_for_download: response.List});

                    break;

                case "Owner_Group_DDL":
                    needAlert = false;
                    if (response.Result === 0) {
                        commit('updateGroupDDLList', { "groupDDL": response.Owner_Group_DDL });
                    }
                    break;

                case "User_Payment_Status":

                    if (response.Result === 0) {
                        commit('updatePaymentStatus', { "User_Payment_Status": response });//look at me
                    }
                    break;

                default:
                    needAlert = true;
                    break;
            }
            if (needAlert || response.Result !== 0)
                commit("addToAlertList", {
                    "text": response.Message,
                    "type": (response.Result === 0 ? "success" : "error")
                });
        },

        codeRequest({ getters, commit }) {
            let loginData = getters.getLoginData;
            if (loginData.waitSecond > 0)
                return;
            loginData.tokenReqData = {};
            loginData.waitSecond = 10;
            if (loginData.timerInterval)
                clearInterval(loginData.timerInterval);
            loginData.timerInterval = setInterval(() => {
                loginData.waitSecond--;
                if (loginData.waitSecond < 0) {
                    loginData.waitSecond = 0;
                    clearInterval(loginData.timerInterval)
                }
                commit('setLoginData', { "loginData": loginData });
            }, 1e3);
            commit('pushQueue', {
                functionName: "AuthCode_Request",
                data: { "Mobile": loginData.mobile.toString() }
            });
            commit('setLoginData', { "loginData": loginData });
        },

        tokenRequest: function ({ commit, getters }) {
            let loginData = getters.getLoginData;
            commit('pushQueue', {
                functionName: "AuthToken_Request",
                data: { "Mobile": loginData.mobile.toString(), "Code": loginData.code.toString() }
            });
        },

        doStart({ commit, dispatch }) {
            let token = getLocalData('token');
            commit('setToken', { token: token });
            if (token && token.length > 0) {
                commit('pushQueue', { functionName: 'Start', data: {} });
                //commit('pushQueue', {functionName: 'User_Profile_Load', data: {}});
            } else
                dispatch('loginPage');
        },
        runAlert({ getters, commit }) {
            let alertList = getters.getAlertList;
            if (alertList.length > 0) {
                while (alertList.length > 0) {
                    Vue.toasted.show(alertList[0].text, { 'type': alertList[0].type });
                    alertList.shift();
                }
                commit('resetAlertList');
            }
        }
    }
});
